import React, { PureComponent } from 'react'
import { selectors as session_selectors } from '../sagas/session';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { actions } from '../sagas/session'
import { Drawer } from 'react-md'
import { NavLink } from 'react-router-dom'
import { checkRole, roleCanView } from './roles'
import '../stylesheets/drawer.css'

class MainDrawer extends PureComponent {

  render () {

    return (
      <Drawer
        id='left-drawer'
        visible={this.props.openState}
        position={'left'}
        desktopType={'full-height'}
        onVisibilityChange={this.props.toggleDrawer}
        type={'temporary'}>
        <div className='nav-list'>
          <div>
            { checkRole('user', this.props.role) &&
            <div>
              <NavLink to='/reservations'>
                <div className='nav-item nav-top reservations-link'>Reservations</div>
              </NavLink>
              <NavLink to='/customers'>
                <div className='nav-item customers-link'>Customers</div>
              </NavLink>
              <NavLink to='/products'>
                <div className='nav-item products-link'>Products</div>
              </NavLink>
              <NavLink to='/kegs'>
                <div className='nav-item kegs-link'>Kegs</div>
              </NavLink>
            </div>
            }
            { checkRole('admin', this.props.role) &&
              <div>
                <NavLink to='/inventory'>
                  <div className='nav-item inventory-link'>Inventory</div>
                </NavLink>
                <NavLink to='/account'>
                  <div className='nav-item account-link'>Account</div>
                </NavLink>
                <NavLink to='/settings'>
                  <div className='nav-item settings-link'>Settings</div>
                </NavLink>
              </div>
            }
            { checkRole('accountant', this.props.role) &&
              <div>
                <NavLink to='/accounting'>
                  <div className='nav-item accounting-link'>Accounting</div>
                </NavLink>
              </div>
            }
          </div>
          <div onClick={ this.logOut }>
            <NavLink className='bottom-item' to={{ pathname: '/', state: { logout: true } }}>
              <div className='nav-item'>Sign Out</div>
            </NavLink>
          </div>
        </div>
      </Drawer>
    )
  }
}

const mapStateToProps = (store) => ({
  token: session_selectors.token(store),
  role: session_selectors.role(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps, null,
)(MainDrawer);



// WEBPACK FOOTER //
// ./src/InternalNavigation/drawer.js